import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import DigitalEffects from './components/DigitalEffects';
import StudentWorks from './components/StudentWorks';
import EraBonus from './components/EraBonus';
import Courses from './components/Courses';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import IntroAnimation from './components/IntroAnimation';
import SeoJsonLd from '@/components/feature/SeoJsonLd';
import PageSeo from '@/components/feature/PageSeo';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: '四相AI影視學院',
    url: SITE_URL,
    description: '四相AI影視學院，提供AI場景生成、動態特效設計、3D動畫製作教學課程。結合最先進的人工智慧技術與傳統影視美學，帶您掌握AI影視製作核心技能。',
    sameAs: [],
    offers: {
      '@type': 'Offer',
      category: 'AI影視教學課程',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '四相AI影視學院',
    url: SITE_URL,
    inLanguage: 'zh-TW',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/blog?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '四相AI影視學院提供哪些課程？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我們提供AI場景生成、動態特效設計、3D動畫製作等專業AI影視教學課程，適合廣告創作者、短影音創作者及個人IP創業者。',
        },
      },
      {
        '@type': 'Question',
        name: '如何報名四相AI影視學院的課程？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以透過網站的「立即報名諮詢」按鈕，或直接聯絡我們進行課程諮詢與報名。',
        },
      },
      {
        '@type': 'Question',
        name: '四相AI影視學院的課程適合哪些人？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '適合廣告從業人員、短影音創作者、創業者及希望建立個人IP的內容創作者，無需特殊技術背景即可學習。',
        },
      },
    ],
  },
];

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [introDone, setIntrosDone] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <PageSeo
        title="四相AI影視學院 - 專業AI影視教學與數位特效製作"
        description="四相AI影視學院，提供AI場景生成、動態特效設計、3D動畫製作教學課程。結合最先進的人工智慧技術與傳統影視美學，帶您掌握AI影視製作核心技能。"
        keywords="四相AI影視學院,AI影視教學,動態特效,3D動畫,數位藝術,影視廣告,AI場景生成,視覺特效,動畫製作"
        canonical={`${SITE_URL}/`}
        ogType="website"
      />
      <SeoJsonLd data={homeJsonLd} id="home-jsonld" />
      {!introDone && <IntroAnimation onComplete={() => setIntrosDone(true)} />}
      <div
        className={`relative bg-black overflow-hidden transition-opacity duration-700 ${
          introDone ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <Navigation scrolled={scrolled} />
        <Hero />
        <EraBonus />
        <About />
        <Portfolio />
        <DigitalEffects />
        <StudentWorks />
        <Courses />
        <Contact />
        <Footer />
      </div>
    </>
  );
}
